<template>
    <div id="app"> 
        <Header />
            <router-view></router-view>
        <Footer />
    </div>
</template>

<script>

import Header from './components/header'
import Footer from './components/footer'
export default {
	components:{
		Header,
		Footer
	}, 
        name: 'App'
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue